import { Link } from 'react-router-dom';
import { useTranslation } from '../../context/TranslationContext';
import { useFrontendAuth } from '../../hooks/useAuth';
import { AccountStatus } from '../../types';
import { translateWithFallback } from '../../utils/translateWithFallback';

function normalizeStatus(raw: unknown): AccountStatus {
    if (raw === AccountStatus.OK || raw === 'OK' || raw === 0) return AccountStatus.OK;
    if (raw === AccountStatus.Warning || raw === 'Warning' || raw === 1) return AccountStatus.Warning;
    if (raw === AccountStatus.Suspended || raw === 'Suspended' || raw === 2) return AccountStatus.Suspended;
    if (raw === AccountStatus.Banned || raw === 'Banned' || raw === 3) return AccountStatus.Banned;
    return AccountStatus.OK;
}

const AccountHealthBadge = () => {
    const { t } = useTranslation();
    const tr = (key: string, fallback: string) => translateWithFallback(t, key, fallback);
    const { user } = useFrontendAuth();
    const strikeCount = user?.strikes?.length ?? 0;
    const status = normalizeStatus(user?.status);
    const isRestricted = status === AccountStatus.Suspended || status === AccountStatus.Banned;

    if (!isRestricted && strikeCount === 0) {
        return (
            <Link
                to="/account-centre"
                className="inline-flex items-center gap-1.5 rounded-full bg-[color-mix(in_srgb,var(--accent-color),transparent_50%)] px-3 py-1 text-xs font-medium text-[var(--text-color)] ring-1 ring-[var(--accent-color)] transition hover:opacity-90"
            >
                <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[var(--accent-color)]" />
                {tr('account.health.goodstanding', 'Good standing')}
            </Link>
        );
    }

    const label = isRestricted
        ? status === AccountStatus.Banned
            ? tr('account.status.label.banned', 'Banned')
            : tr('account.status.label.suspended', 'Suspended')
        : tr('account.health.strikeswarning', `${strikeCount} strike(s)`)
              .replace('{count}', String(strikeCount))
              .replace('{{count}}', String(strikeCount));

    return (
        <Link
            to="/account-centre"
            className="inline-flex items-center gap-1.5 rounded-full bg-[color-mix(in_srgb,var(--text-color),transparent_85%)] px-3 py-1 text-xs font-medium text-[var(--text-color)] ring-1 ring-[color-mix(in_srgb,var(--text-color),transparent_60%)] transition hover:opacity-90"
        >
            <span aria-hidden>⚠️</span>
            {label}
        </Link>
    );
};

export default AccountHealthBadge;